import React, { useEffect, useState } from 'react';
import Card from '../components/CardVocab';
import data5 from './../data/vocabularyn5.json';
import data4 from './../data/vocabularyn4.json';
import data3 from './../data/vocabularyn3.json';
import data2 from './../data/vocabularyn2.json';
import data1 from './../data/vocabularyn1.json';
import BackToTopButton from '../components/BackToTopButton';

const Vocabulary = () => {

    const [level, setValue] = useState('');
    const handleLevelClick = (level) => {
        setValue(level);
    };

    const [showAll, setShowAll] = useState(undefined); // undefined = normal card behavior
    const [resetSignal, setResetSignal] = useState(0);
    const [pendingMap, setPendingMap] = useState({});

    const handleShowAll = () => {
        setShowAll(true);
    };

    const handleHideAll = () => {
        setShowAll(false);
    };

    const handleReset = () => {
        // 1. Clear override
        setShowAll(undefined);

        // 2. Remove all saved localStorage
        if (level === 'N5') {
            data5.forEach(k => {
                localStorage.removeItem(`vocab-${k.word}`);
            });
        } else if (level === 'N4') {
            data4.forEach(k => {
                localStorage.removeItem(`vocab-${k.word}`);
            });
        } else if (level === 'N3') {
            data3.forEach(k => {
                localStorage.removeItem(`vocab-${k.word}`);
            });
        } else if (level === 'N2') {
            data2.forEach(k => {
                localStorage.removeItem(`vocab-${k.word}`);
            });
        } else {
            data1.forEach(k => {
                localStorage.removeItem(`vocab-${k.word}`);
            });
        }

        for (let key in localStorage) {
            if (key.startsWith("vocabPending")) {
                localStorage.removeItem(key);
            }
        }

        // 3. Wait a tick to ensure showAll is undefined before resetting
        setTimeout(() => {
            setResetSignal(prev => prev + 1);
            setPendingMap({});
        }, 50);
    };

    useEffect(() => {
        const pending = JSON.parse(localStorage.getItem('vocabPending') || '{}');
        setPendingMap(pending);
    }, []);

    const handleTogglePending = (word) => {
        setPendingMap((prev) => {
            const updated = { ...prev, [word]: !prev[word] };
            localStorage.setItem('vocabPending', JSON.stringify(updated));
            return updated;
        });
    };

    return (
        <div className="px-6 pb-6 pt-6">
            <h1 className="text-4xl font-extrabold text-gray-800 mb-8 text-center">
                VOCABULARY {level}
            </h1>
            <div className="flex justify-center space-x-4 mb-4">
                <button
                    onClick={handleShowAll}
                    className="px-4 py-2 bg-green-400 text-white rounded hover:bg-green-500 active:scale-95 transition-transform"
                >
                    Show All Details
                </button>
                <button
                    onClick={handleHideAll}
                    className="px-4 py-2 bg-red-400 text-white rounded hover:bg-red-500 active:scale-95 transition-transform"
                >
                    Hide All Details
                </button>
                <button
                    onClick={handleReset}
                    className="px-4 py-2 bg-gray-400 text-white rounded hover:bg-gray-500 active:scale-95 transition-transform"
                >
                    Reset All
                </button>
            </div>
            <h3 className="text-gray-600 mb-8 text-center">
                Single tap - Play pronunciation<br />
                Double tap - Show / hide details<br />
                Long press - Mark / unmark for review
            </h3>
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4 pb-8">
                <button class="text-white bg-blue-500 border-0 py-2 px-6 focus:outline-none hover:bg-blue-600 rounded text-lg"
                    onClick={() => handleLevelClick('N5')}>N5</button>
                <button class="text-white bg-blue-500 border-0 py-2 px-6 focus:outline-none hover:bg-blue-600 rounded text-lg"
                    onClick={() => handleLevelClick('N4')}>N4</button>
                <button class="text-white bg-blue-500 border-0 py-2 px-6 focus:outline-none hover:bg-blue-600 rounded text-lg"
                    onClick={() => handleLevelClick('N3')}>N3</button>
                <button class="text-white bg-blue-500 border-0 py-2 px-6 focus:outline-none hover:bg-blue-600 rounded text-lg"
                    onClick={() => handleLevelClick('N2')}>N2</button>
                <button class="text-white bg-blue-500 border-0 py-2 px-6 focus:outline-none hover:bg-blue-600 rounded text-lg"
                    onClick={() => handleLevelClick('N1')}>N1</button>
            </div>
            {level === 'N1' &&
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4">
                    {data1.map(data => (
                        <Card key={data.word}
                            word={data.word}
                            reading={data.reading}
                            meaning={data.meaning}
                            showOverride={showAll}
                            resetSignal={resetSignal}
                            isPending={pendingMap[data.word]}
                            onTogglePending={handleTogglePending}
                        />
                    ))}
                </div>
            }
            {level === 'N2' &&
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4">
                    {data2.map(data => (
                        <Card key={data.word}
                            word={data.word}
                            reading={data.reading}
                            meaning={data.meaning}
                            showOverride={showAll}
                            resetSignal={resetSignal}
                            isPending={pendingMap[data.word]}
                            onTogglePending={handleTogglePending}
                        />
                    ))}
                </div>
            }
            {level === 'N3' &&
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4">
                    {data3.map(data => (
                        <Card key={data.word}
                            word={data.word}
                            reading={data.reading}
                            meaning={data.meaning}
                            showOverride={showAll}
                            resetSignal={resetSignal}
                            isPending={pendingMap[data.word]}
                            onTogglePending={handleTogglePending}
                        />
                    ))}
                </div>
            }
            {level === 'N4' &&
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4">
                    {data4.map(data => (
                        <Card key={data.word}
                            word={data.word}
                            reading={data.reading}
                            meaning={data.meaning}
                            showOverride={showAll}
                            resetSignal={resetSignal}
                            isPending={pendingMap[data.word]}
                            onTogglePending={handleTogglePending}
                        />
                    ))}
                </div>
            }
            {level === 'N5' &&
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4">
                    {data5.map(data => (
                        <Card key={data.word}
                            word={data.word}
                            reading={data.reading}
                            meaning={data.meaning}
                            showOverride={showAll}
                            resetSignal={resetSignal}
                            isPending={pendingMap[data.word]}
                            onTogglePending={handleTogglePending}
                        />
                    ))}
                </div>
            }
            <BackToTopButton />
        </div>
    );
};

export default Vocabulary;